<template>
    <div>
        <ul v-if="list && list.length">
            <li :class="['d-flex reservation-event mx-3 my-2 p-1', { selected: (e.id === selectedEvent ) }]" v-for="e in list" @click="select($event, e)">
                <event :event="e" :reschedule="isReschedule"></event>
            </li>
        </ul>
        <p class="m-4" v-else>No products found. Please try again with a broader criteria.</p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Event from './Event'

    export default {
        props: {
            isReschedule: {
                type: Boolean,
                default: false,
            }
        },
        data: function() {
            return {
                selection: null,
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'getNewReservationSetup',
                'getEvents',
            ]),
            selectedEvent: function() {
                if (this.selection) {
                    return this.selection.id;
                }
                else if (this.getClonedReservation && this.getClonedReservation.event !== undefined && this.getClonedReservation.event) {
                    return this.getClonedReservation.event.id;
                }

                return null;
            },
            list: function() {
                return this.getNewReservationSetup.list;
            }
        },
        methods: {
            select: function(event, selection) {
                this.selection = selection;
                this.$emit('addedEvent', selection);
            }
        },
        components: {
            Event
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .reservation-event {
        position: relative;
        padding: 0.5rem;
        border: 1px solid $light;
        border-radius: 4px;

        img {
            border-radius: 6px;
            margin-right: 1rem;
        }

        .logo {
            position: absolute;
            top: 1rem;
            right: 1rem;
        }

        .price {
            position: absolute;
            bottom: 1rem;
            right: 1rem;
        }

        &.selected {
            border: 2px solid $color-3;
            padding: calc(0.5rem - 2px);
        }
    }
</style>


// WEBPACK FOOTER //
// Events.vue?2b80c9e4